module.exports = __webpack_public_path__ + "static/img/2.6403874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-de-mascotas/2.png
// module id = hFfX
// module chunks = 0